/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import TableTab from "UpduoLibrary/TableTab";
import { MembersTableTabType } from "./types";

import * as UpduoAnalytics from "config/UpduoAnalytics";

interface TableTabBarProps {
  memberName: string;
  tabChoice: MembersTableTabType;
  onTabChoice: (choice: MembersTableTabType) => void;
}

export default function TableTabBar({
  memberName,
  tabChoice,
  onTabChoice,
}: TableTabBarProps) {
  return (
    <View style={{ flexDirection: "row" }}>
      <TableTab
        isActive={tabChoice === "members"}
        label={memberName}
        onPress={() => {
          UpduoAnalytics.logEvent("user-select-member-table");
          onTabChoice("members");
        }}
      />
      <TableTab
        isActive={tabChoice === "unregisteredMembers"}
        label={"Unregistered Members"}
        onPress={() => {
          UpduoAnalytics.logEvent("user-select-unregistered-member-table");
          onTabChoice("unregisteredMembers");
        }}
      />
      <TableTab
        isActive={tabChoice === "roles"}
        label={"Roles"}
        onPress={() => {
          UpduoAnalytics.logEvent("user-select-roles-table");
          onTabChoice("roles");
        }}
      />
    </View>
  );
}
